import utility from './utility'

const blueshyftLocations = {
    init: function () {
        const findAnOutletButton = document.getElementById("find-an-outlet");
        if (findAnOutletButton) {
            findAnOutletButton.onclick = () => {
                this.findAnOutlet(true);
            }
        }
        const blueshyftMapContainer = document.getElementById("blueshyft-location--container");
        if (blueshyftMapContainer) {
            this.findAnOutlet(false);
        }
    },

    findAnOutlet: function(displayAccountPopup) {
        let map, marker, addressInputValue, searchAutoComplete;
        let userLocation = {};
        let userSearchLocation = {};
        let locations = {};
        let markersArray = [];
        const addressInput = document.getElementById("blueshyft-location--address-input");

        if (typeof initMap === "function") {
            // check if map already exists
            window.initMap();
        }
        else {
            loadGoogleMapScripts();
        }

        window.initMap = function () {
            const infoWindow = new google.maps.InfoWindow();
            addressInput.value = "";
            let sydney = {
                coords: {
                    latitude: -33.867,
                    longitude: 151.195
                }
            };

            if (navigator.geolocation) {
                // Ask for user device location
                navigator.geolocation.getCurrentPosition(createMap,
                    () => {
                        createMap(sydney, true);
                    }
                );
            }
            else {
                // Browser doesn't support Geolocation, use Postcode
                createMap(sydney, true);
            }

            function createMap(position, usePostCode) {
                userLocation = {
                    "lat": position.coords.latitude,
                    "lng": position.coords.longitude
                }

                map = new google.maps.Map(document.getElementById("blueshyft-map"), {
                    center: userLocation,
                    zoom: 11,
                });

                if (usePostCode) {
                    // get user details (postcode) and find lat, lng using place details api
                    fetch("/api/web/account/get-address/").then((response) => response.json().then(getLatLngUsingPostCode));
                }
                else {
                    marker = new google.maps.Marker({
                        position: userLocation,
                        map
                    });
                    markersArray.push(marker);
                    getStoreLocations(position.coords);
                }

                if (addressInput) {
                    // User Inputs Location Address
                    searchAutoComplete = new window.google.maps.places.Autocomplete(addressInput, { types: ['geocode'], componentRestrictions: { country: 'au' } });
                    searchAutoComplete.setFields(['geometry.location']);

                    searchAutoComplete.addListener("place_changed", function () {
                        clearMarkers();
                        addressInputValue = addressInput.value;
                        userSearchLocation.latitude = searchAutoComplete.getPlace().geometry.location.lat();
                        userSearchLocation.longitude = searchAutoComplete.getPlace().geometry.location.lng();
                        marker = new google.maps.Marker({
                            position: { lat: userSearchLocation.latitude, lng: userSearchLocation.longitude },
                            map
                        });
                        markersArray.push(marker);
                        getStoreLocations(userSearchLocation);
                        map.setCenter({ lat: userSearchLocation.latitude, lng: userSearchLocation.longitude });
                    });
                }

            }

            function getStoreLocations(userLocation) {
                const { latitude, longitude } = userLocation;
                const ajaxOptions = {
                    url: `/api/web/account/get-blueshyft-locations?latitude=${latitude}&longitude=${longitude}&count=200`,
                    method: "POST",
                    success: (e) => {
                        locations = JSON.parse(e.target.responseText);
                        plotStoreLocations(locations, userLocation);
                    },
                };
                utility.ajaxRequest(ajaxOptions);
            }

            function plotStoreLocations(locations, userLocation) {
                if (infoWindow) {
                    // close all open info windows
                    infoWindow.close();
                }
                const userAddress = addressInputValue ? addressInputValue : new google.maps.LatLng(userLocation.latitude, userLocation.longitude);
                const customMarkerIcon = "/assets/icons/custom-marker.png";
                locations.map(location => {
                    const latLng = new google.maps.LatLng(location.Latitude, location.Longitude);
                    const shopAddress = `${location.ShopNo ? location.ShopNo : ""} ${location.Street ? location.Street : ""}, ${location.Suburb ? location.Suburb : ""}, ${location.State ? location.State : ""}, ${location.PostCode ? location.PostCode : ""}`;
                    const content = `<p><b>${location.ShopName}</b></p><p>${location.Street ? location.Street : ""}, ${location.Suburb ? location.Suburb : ""}, ${location.State ? location.State : ""}, ${location.PostCode ? location.PostCode : ""}</p>
                        <a title="Get Driving Directions" target="_blank" class="button button-orange-solid" 
                            href="https://www.google.com/maps?saddr=${userAddress}&daddr=${shopAddress}">Get Directions</a>`;

                    const locationmarker = new google.maps.Marker({
                        position: latLng,
                        map: map,
                        icon: customMarkerIcon,
                    });

                    locationmarker.addListener("click", () => {
                        infoWindow.close();
                        infoWindow.setContent(content);
                        infoWindow.open(locationmarker.getMap(), locationmarker);
                        map.setZoom(13);
                        map.setCenter(locationmarker.getPosition());
                    });
                    markersArray.push(locationmarker);

                });
            }

            function getLatLngUsingPostCode(user) {
                addressInputValue = `${user.UnitNumber ? user.UnitNumber : ""} ${user.StreetNumber} ${user.Street}, ${user.Suburb} ${user.State} ${user.PostCode}`
                let request = {
                    query: addressInputValue,
                    fields: ['geometry.location'],
                };

                let service = new google.maps.places.PlacesService(map);
                service.findPlaceFromQuery(request, function (results, status) {
                    if (status === google.maps.places.PlacesServiceStatus.OK) {
                        let coords = {
                            latitude: results[0].geometry.location.lat(),
                            longitude: results[0].geometry.location.lng(),
                        };
                        marker = new google.maps.Marker({
                            position: results[0].geometry.location,
                            map
                        });
                        markersArray.push(marker);
                        getStoreLocations(coords);
                        map.setCenter(results[0].geometry.location);
                    }
                });
            }

            function clearMarkers() {
                for (let i = 0; i < markersArray.length; i++) {
                    markersArray[i].setMap(null);
                }
            }

            if (displayAccountPopup) {
                utility.showPopup(document.getElementById("map-popup"));
            }
        }

        function loadGoogleMapScripts() {
            var script = document.createElement('script');
            script.type = 'text/javascript';
            script.async = 'true';
            script.defer = 'true';
            script.src = `https://maps.googleapis.com/maps/api/js?v=3&key=AIzaSyAChMt1LjDgHq1YgmmSyyStnheqT8M0Y3Q&v=weekly&libraries=places&callback=initMap`;
            document.getElementsByTagName("head")[0].appendChild(script);
        }
    }
}

export default blueshyftLocations;


// WEBPACK FOOTER //
// ./assets/src/js/classes/blueshyftLocations.js